export const ORGANIZATION_HIDDEN_FIELDS = [
  'business_contact_ssn',
  'business_contact_dl',
  'business_owner1_ssn',
  'business_owner1_dl',
  'business_owner2_ssn',
  'business_owner2_dl',
  'business_owner3_ssn',
  'business_owner3_dl',
] as const;

/** Opens the org page on one Additional Details tab, for example `?tab=proposals`. */
export const ORGANIZATION_TAB_SEARCH_PARAM = 'tab';
export const ORGANIZATION_PROPOSALS_TAB = 'proposals';

export const OrganizationHealth = {
  GOOD_STANDING: 'Good Standing',
  NEEDS_ATTENTION: 'Needs Attention',
} as const;

export const EntityType = {
  C_CORPORATION: 'C_CORPORATION',
  COOPERATIVE_CO_OP: 'COOPERATIVE_CO_OP',
  CORPORATION: 'CORPORATION',
  GENERAL_PARTNERSHIP: 'GENERAL_PARTNERSHIP',
  HYBRID_LLC: 'HYBRID_LLC',
  JOINT_VENTURE: 'JOINT_VENTURE',
  LLC: 'LLC',
  LLC_TAXED_AS_C_CORPORATION: 'LLC_TAXED_AS_C_CORPORATION',
  LLC_TAXED_AS_S_CORPORATION: 'LLC_TAXED_AS_S_CORPORATION',
  LIMITED_LIABILITY_LIMITED_PARTNERSHIP: 'LIMITED_LIABILITY_LIMITED_PARTNERSHIP',
  LIMITED_LIABILITY_PARTNERSHIP: 'LIMITED_LIABILITY_PARTNERSHIP',
  LIMITED_PARTNERSHIP: 'LIMITED_PARTNERSHIP',
  MULTI_MEMBER_LLC: 'MULTI_MEMBER_LLC',
  NONPROFIT: 'NONPROFIT',
  PROFESSIONAL_LLC: 'PROFESSIONAL_LLC',
  SINGLE_MEMBER_LLC: 'SINGLE_MEMBER_LLC',
  S_CORPORATION: 'S_CORPORATION',
  SOLE_PROPRIETORSHIP: 'SOLE_PROPRIETORSHIP',
} as const;

export const AccountingModel = {
  CASH: 'CASH',
  ACCRUAL: 'ACCRUAL',
} as const;
